import {Component} from '@angular/core';
import {MatDialogRef as MatDialogRef} from '@angular/material/dialog';
import {IconfirmDialogSettings} from '../../../services/modal/dialogs-mt.service';

@Component({
    selector: 'app-app-confim-action',
    templateUrl: './app-confim-action.component.html',
    styleUrls: ['./app-confim-action.component.scss']
})
export class AppConfimActionComponentMT {
    public dialogSettings!: IconfirmDialogSettings

    constructor(
        public dialogRefConfirm: MatDialogRef<AppConfimActionComponentMT>
    ) {
    }

    submitAction() {
        this.dialogRefConfirm.close({isConfirmed: true});
    }

    cancelAction() {
        this.dialogRefConfirm.close({isConfirmed: false});
    }

}
